import axios from 'axios'

const instance = axios.create({
  // baseURL: 'http://localhost:8080',
  timeout: 100000,
  params: {}, // do not remove this, its added to add params later in the config
})

export default instance
